import { useEffect, useState  } from "react";
import { fetchData } from "@/lib/supabase-function";

export default function SEOJsonLD() {
  
  useEffect(() => {
    const loadAndSetSchema = async () => {
      const services = await fetchData(
        "services",
        "title, slug",
        "srno",
        "is_active",
        true,
        false
      );

      if (services && services.length > 0) {
        const schema = {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "Core Solution",
          "url": "https://www.coresol.co",
          "logo": "https://www.coresol.co/logo.png",
          "description": "Core Solution offers software development, web & mobile apps, ERP, UI/UX, QA testing, and data analytics. Trusted IT partner for digital growth.",
          "hasOfferCatalog": {
            "@type": "OfferCatalog",
            "name": "Core Solution Services",
            "itemListElement": services.map((s: any) => ({
              "@type": "Offer",
              "itemOffered": { "@type": "Service", "name": s.title }
            }))
          }
        };

        // Create script tag
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.text = JSON.stringify(schema, null, 2);
        document.head.appendChild(script);
      }
    };

    loadAndSetSchema();
  }, []);
/*useEffect(() => {
    const detectCountry = async () => {
      try {
        const res = await fetch("https://ipapi.co/json/");
        const data = await res.json();
        const code = data?.country_code?.toLowerCase() || "in";
        const savecode = localStorage.getItem("Core-country");        
        if (savecode!=code) {navigate(code); }
        localStorage.setItem("Core-country", code);
        localStorage.setItem("Core-countrycode", data?.country_calling_code || "");      
      } catch (err) {
        console.error("Country detection failed:", err);        
      }
    };

    detectCountry();
  }, [navigate]);*/
  return null;
}
